import { LRUCache } from 'lru-cache';
export class CacheUtils {
    static { this.cache = new LRUCache({
        max: 100, // Nombre maximum d'éléments dans le cache
    }); }
    static getCache(key) {
        return this.cache.get(key);
    }
    static setCache(key, value) {
        this.cache.set(key, value);
    }
}
